import { render } from "./SubmitInfo.vue?vue&type=template&id=ea704888&scoped=true"
import script from "./SubmitInfo.vue?vue&type=script&lang=js"
export * from "./SubmitInfo.vue?vue&type=script&lang=js"

import "./SubmitInfo.vue?vue&type=style&index=0&id=ea704888&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea704888"]])

export default __exports__